export const getCompanyOptions = (store) => {
  const companies = store.company.companies;

  return companies.map((item) => ({ value: item._id, label: item.name }));
};
